<template>
  <div>
    <template v-if="loading === true">
      <loading />
    </template>
    <template v-else>
      <div class="col s12 m12 no-padding contact-section">
        <div class="col s12 no-padding title-buttons-wrapper">
          <div class="col s6 redes-socias-comp">
            <h6>
              Redes Sociais
              <i v-if="redes_sociais.length > 0" class="material-icons">check</i>
              <template v-else>
                <i v-if="meta.censo_domain[selectedMunicipio].formulario_documentos_obrigatorios.contatos.includes('redes_sociais')" class="material-icons red-text">error</i>
              </template>
            </h6>
          </div>
          <div class="col s6">
            <a v-if="show_form === false" @click="showCarousel" class="waves-effect waves-light btn right">Adicionar Rede Social</a>
            <a v-else @click="showCarousel" class="waves-effect waves-light btn red right">Cancelar</a>
          </div>
        </div>
        <div v-if="show_form === false && redes_sociais.length > 0">
          <div v-for="(rs, i) in redes_sociais" v-bind:key="i" class="col s12 m6">
            <div class="card card-redes-socias">
              <div class="card-content">
                <div class="email-wrapper">
                  <i v-bind:class="`fa fa-${rs['info']['icon']}`"/>
                  <a target="_blank" v-bind:href="rs['info']['url']" class="rs-endereco">@{{ rs['rede_social_endereco'] }}</a>
                </div>
              </div>
              <div class="card-action">
                <LastUpdate v-bind:author="rs['author']" />
                <div class="btns-wrapper">
                  <a @click="deleting_rs = rs" href="#modalDelRS" class="tooltipped action-delete modal-trigger" data-tooltip="Deletar email">
                    <i class="material-icons">delete</i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="show_form === true" class="col s12 no-padding lista-email-wrapper">
          <FormRedesSociais @submitRedeSocial="postNewRedeSocial" />
        </div>
      </div>
    </template>
    <div id="modalDelRS" class="modal">
      <div class="modal-content">
        <h4 v-if="deleting_rs !== null">
          Tem certeza que você deseja remover este <strong>registro</strong>?
        </h4>
      </div>
      <div class="modal-footer">
        <a @click="deleteRedeSocial(deleting_rs)" class="modal-close btn-flat red">Remover</a>
        <a @click="deleting_rs = null" href="javascript: void(0)" class="modal-close btn-flat grey">Cancelar</a>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from '@/components/Loading.vue'
  import axios from 'axios'
  import {CONFIG} from '@/config/config.js'
  import LastUpdate from '@/components/utils/LastUpdate.vue'
  import FormRedesSociais from './FormRedesSociais.vue'
  

  export default {
    name: 'RedesSociais',
    components: {
      loading: Loading,
      FormRedesSociais,
      LastUpdate
    },
    props: {
      pf_id: String
    },
    data (){
      return {
        meta: this.$store.state.meta.data,
        show_form: false,
        loading: true,
        redes_sociais: [],
        new_rede_social: null,
        error_fields: {},
        selectedMunicipio: localStorage.selectedMunicipio,
        deleting_rs: null,
      }
    },
    methods: {
      getRedesSociais(){
        axios.get(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/rede-social/${this.pf_id}/`)
        .then(({ data: { data: { SocialAPI } } }) => {
          this.redes_sociais = SocialAPI.map((rede_social) => {
            return {...rede_social, ...{'info': this.getRedeSocialInfo(rede_social)}}
          })
        })
        .catch((error) => {
          if(error.response.status !== 404){
            M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          } else {
            this.redes_sociais = []
          }
        })
        .finally(() => {
          this.loading = false
          this.initFields()
        })
      },
      postNewRedeSocial(rede_social) {
        this.loading = true
        this.show_form = false
        axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/rede-social/`, {
          "pf_id": this.pf_id,
          "rede_social_tipo": rede_social['rede_social_tipo'],
          "rede_social_endereco": rede_social['rede_social_endereco'].replace('@', '')
        })
        .then(_response => {
          M.toast({html: "Dados cadastrados com sucesso!"})
          this.getRedesSociais()
        })
        .catch(_error => {
          M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          this.loading = false
        })
      },
      deleteRedeSocial(rede_social) {
        this.loading = true
        axios({
          method: "DELETE",
          url: `${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/rede-social/${this.pf_id}/${rede_social['rede_social_id']}/`,
          data: {}
        })
        .then((response) => {
          M.toast({html: "Dados removidos com sucesso!"})
          this.getRedesSociais()
        })
        .catch((error) => {
          M.toast({html: "Ops! Não foi possível realizar esta operação...tente novamente em instantes."})
          this.loading = false
        })
        .finally(() => {
          this.deleting_rs = null
        })
      },
      showCarousel() {
        this.show_form = !this.show_form
        if (this.show_form === true) {
          this.initFields()
          this.new_rede_social = {

          }
        }
      },
      getRedeSocialInfo(rede_social){
        if(rede_social['rede_social_tipo'] in this.meta.url_redes_sociais){
          return {
            url: this.meta.url_redes_sociais[rede_social['rede_social_tipo']].replace('%s', rede_social['rede_social_endereco']),
            icon: (rede_social['rede_social_tipo'] === 'tiktok' ? 'hashtag' : rede_social['rede_social_tipo'])
          }
        } else {
          return {
            url: rede_social['rede_social_endereco'],
            icon: 'hashtag'
          }
        }
      },
      initFields() {
        setTimeout(() => {
          M.Modal.init(document.querySelectorAll('.modal'))
          M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        }, 300);
      }
    },
    mounted() {
      this.getRedesSociais()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/steps/contatos/RedesSociais.vue